// extracted by mini-css-extract-plugin
export default {"container":"text_container__3h5Gq","subtitle":"text_subtitle__SPdyt","paragraph":"text_paragraph__nb3hj","withBottomMargin":"text_withBottomMargin__2ibjc"};